import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import b from 'b_';
import { Card } from '../Fuse';
import FuseConsoleCardFooter from '../ConsoleFragments/FuseConsoleCardFooter';
import './PolicyModalHeader.css';

const block = b.lock('PolicyModalHeader');

class PolicyModalHeaderLayout extends Component {
    static propTypes = {
        readOnly: PropTypes.bool,
        footer: PropTypes.string,
        title: PropTypes.string.isRequired,
        alert: PropTypes.object
    };

    render() {
        const { readOnly, footer, title, alert } = this.props;

        return <Card title={title}>
            {alert || null}
            <div className={block('Content', { readOnly, hasFooter: !!footer })}>
                {React.Children.map(this.props.children, (child) => {
                    return React.cloneElement(child, {
                        readOnly, className: block('Field', { readOnly }),
                    });
                })}
            </div>
            {footer ? <FuseConsoleCardFooter text={footer}/> : null}
        </Card>;
    }
}

export default observer(PolicyModalHeaderLayout);
